<template>
    <div class="content">
        <div class="card my-1">
            <div
                    class="collapse show"
                    aria-labelledby="headingTwo"
                    data-parent="#accordionResult"
            >
                <div class="card-body">
                    <div class="bs-component"></div>
                    <div class="col-lg-12">
                        <h5>
                            <span class="text-primary">{{$t("title.em.workflow.task.complete")}}</span>
                        </h5>
                    </div>
                </div>
            </div>
            <!--            <b-alert show variant="success" v-if="this.$route.params.usedBy==='approval'">-->
            <b-alert show variant="success">
                <b-row>
                    <b-col md="1" class="text-right my-2"
                           v-if="!attachmentDisable">
                        <strong>{{$t("title.em.workflow.task.attachment")}}:</strong>
                    </b-col>
                    <b-col md="2" class="my-1"
                           v-if="!attachmentDisable">
                        <em-attachment
                                isEditing
                                @idsChanged="handleIdsChanged"
                        ></em-attachment>
                    </b-col>
                    <b-col md="1" class="text-right my-2"
                           v-if="!commentDisable">
                        <strong>{{$t(commentTitle)}}:</strong>
                    </b-col>
                    <b-col md="4" class="my-1" v-if="!commentDisable">
                        <b-form-input id="input-comment" v-model="workflowCompleteTaskForm.comment" type="text"
                                      :placeholder="$t(commentPlaceholderText)"/>
                    </b-col>
                    <b-col md="2" class="my-1">
                        <b-button-group>
                            <mmf-button v-if="!approveDisable" ref="approve" :type="approveButtonType"
                                        :class="approveClass"
                                        :customLabel="approveLabel"
                                        :showName="approveLabel!==null"
                                        @click="handleClick(approveValue)">
                            </mmf-button>
                            <mmf-button v-if="!rejectDisable" ref="reject" :type="rejectButtonType"
                                        :class="rejectClass"
                                        :customLabel="rejectLabel"
                                        :showName="rejectLabel!==null"
                                        @click="handleClick(rejectValue)">
                            </mmf-button>
                        </b-button-group>
                    </b-col>
                    <b-col md="2" class="my-1">
                        <!-- 作用域具名插槽，可自定义列表项按钮 -->
                        <slot name="customSlot" :completeTaskForm="workflowCompleteTaskForm"></slot>
                    </b-col>
                </b-row>
            </b-alert>
        </div>
    </div>
</template>

<script>

import EmAttachment from "@/components/em/EmAttachment";
import MmfButton from "@/components/em/EmButton";
import {mapActions} from "vuex";

export default {
        name: "EmWorkflowTaskComplete",
        components: {EmAttachment, MmfButton},
        props: {
            commentPlaceholderText: {
                type: String,
                default: "text.em.workflow.task.comment.placeholder"
            },
            commentTitle: {
                type: String,
                default: "title.em.workflow.task.comment"
            },
            attachmentDisable: {
                type: Boolean,
                default: false
            },
            commentDisable: {
                type: Boolean,
                default: false
            },
            approveDisable:{
                type: Boolean,
                default: false
            },
            rejectDisable:{
                type: Boolean,
                default: false
            },
            approveValue: {
                type: Number,
                default: 1
            },
            rejectValue: {
                type: Number,
                default: 0
            },
            approveLabel: {
                type: String,
                default: null
            },
            approveClass: {
                type: String,
                default: 'btn btn-success btn-sm'
            },
            rejectLabel: {
                type: String,
                default: null
            },
            rejectClass: {
                type: String,
                default: 'btn btn-warning btn-sm'
            },
            approveButtonType:{
                type: String,
                default: "approve"
            },
            rejectButtonType:{
                type: String,
                default: "reject"
            },
            taskId: String,
            callbackApi: String
        },
        data: function () {
            return {
                workflowCompleteTaskForm: {
                    taskId: this.taskId,
                    approved: 0,
                    comment: "",
                    attachmentIds: "",
                    dueDate: "",
                    callbackApi: this.callbackApi
                }
            }
        },
        methods: {
            handleIdsChanged(ids) {
                this.workflowCompleteTaskForm.attachmentIds = ids
            },
            handleClick(approved) {
                this.workflowCompleteTaskForm.approved = approved
                this.completeTask(this.workflowCompleteTaskForm)
            },
            completeTask(form) {
                console.log("this is emWorkflowTaskComplete")
                console.log("form is ")
                console.log(form)
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_WORKFLOW_URL + "/completeTask",
                    data: form
                }).then(response => {
                    //todo: 显示成功提示
                    console.log(response)
                    if (response.status === 200) {
                        //todo: 被逼的啊，成功了直接返回数据对象，失败了返回带code和msg和data的封装对象。有机会统一改一下，改成都返回封装对象
                        if (response.data.code && response.data.code !== 200 && response.data.msg) {
                            this.showWarning({userAlertWarningStr: response.data.msg, userAlertWarningVisible: true})
                        } else {
                            this.showSuccess({userAlertSuccessStr: "任务提交成功"})
                            //向外触发事件
                            this.$emit("taskCompleted")
                        }
                    }
                })
            },
            ...mapActions("base", ["showSuccess", "showDanger", "showWarning"])
        }
    }
</script>

<style scoped>

</style>